import { css } from "styled-components";

const GrowIntoPlace = css`
    @keyframes growIntoPlace {
        from {
            opacity: 0;
            transform: scale(0);
        }
        to {
            opacity: 1;
            transform: scale(1);
        }
    }
    animation: growIntoPlace 0.5s ease-in-out 0s 1 normal forwards;
`;

const Bounce = css`
    @keyframes bounce {
        0% {
            transform: scale(1);
        }
        25% {
            transform: scale(0.7);
        }
        50% {
            transform: scale(1);
        }
        75% {
            transform: scale(0.9);
        }
        100% {
            transform: scale(1);
        }
    }
    animation: bounce 500ms ease-in-out;
`;

const ScaleUpAndDown = css`
    @keyframes scaleUpAndDown {
        0% {
            transform: scale(1);
        }
        50% {
            transform: scale(1.05);
        }
        100% {
            transform: scale(1);
        }
    }
    animation: scaleUpAndDown 1s ease-in-out;
`;

export const Animations = {
    Bounce,
    ScaleUpAndDown,
    GrowIntoPlace
};

export const Timing = {
    standard: "ease-in-out"
};
